const yup = require("yup");

// Schema for createcollegerules
const create = yup.object({
  programme: yup.string().required("Programme group is required"),
  name: yup.string().required("Name is required"),
  status: yup.boolean().required("Status is required"),
  serviceTypeID: yup.number().required("Remita Service Type ID is required"),
  amount: yup.number().required("Amount is required"),
});

module.exports = {
  create,
};
